import React, { useEffect, useState } from "react";
import { DescriptionModal, ViewMore } from "../../comman/action/ViewMore";
import { PaginationShow } from "../../comman/action/Pagination";
import NotFound from "../../components/not-found/NotFound";
import { ViewIcon } from "../../comman/action/ViewIcon";
import Switch from "../../components/Switch/Switch";
import {
  DatePicker,
  cashConverter,
  dateFormat,
  searchDateFormat,
} from "../../components/Form";
import PsychologySharpIcon from "@mui/icons-material/PsychologySharp";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Button, SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { Input, ReactSelector, Select, TextArea } from "../../components/Form";
import { masterCategory } from "../../services/masterApi";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../comman/Message";
import { deleteResourceApi, fathResourceApi } from "../../services/resource";
import EditIcon from "../../comman/action/EditIcon";
import ChangeStatusResource from "./ChangeStatusResource";
import { DeleteIcon, DeleteModal } from "../../comman/action/DeleteIcon";

const ResourceManagement = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let searchStartDate = searchParam.get("startDate") || "";
  let searchEndDate = searchParam.get("endDate") || "";

  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);
  const [orderByFund, setOrderByFunds] = useState("");
  const [orderByCreatedDate, setOrderByCreateDate] = useState("");
  const [fieldName, setFieldName] = useState("createdAt");
  const [direction, setDirection] = useState("ASC");
  const [resourceList, setResourceList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [categoryList, setCategoryList] = useState([]);
  const [categoryIds, setCategoryId] = useState("");
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [statusName, setStatusName] = useState("");
  const [moreModal, setMoreModal] = useState(false);
  const [moreValue, setMoreValue] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);

  //----------see-more-in-modal----------
  const handleSeeMore = (email) => {
    setMoreModal(true);
    setMoreValue(email);
  };
  //-----------Handel-Pagination-----------
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //-----------Handel-status-----------
  const statusUpdateHandler = (id, status, name) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
    setStatusName(name);
  };
  //------------handle-Delete---------------
  const handleDelete = (id, name) => {
    setDeleteModal(true);
    setStatusId(id);
    setStatusName(name);
  };
  //-----------Handel-refresh-icon-----------
  const refreshHandler = (event) => {
    setSearch("");
    setCategoryId("");
    searchParam.delete("sortBy");
    searchParam.delete("startDate");
    searchParam.delete("endDate");
    setSearchParam(searchParam);
  };
  // -----------start-Date-search--------------
  const handleStartDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("startDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  //-----------end-Date-search-----------
  const handleEndDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("endDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  //--------------sorting-Funds------------------------
  const orderByFunds = () => {
    const newDirection = orderByFund === "ASC" ? "DESC" : "ASC";
    setOrderByFunds(newDirection);
    setFieldName("totalInvestedAmount");
    setDirection(newDirection);
  };
  //--------------sorting-CreatedAt------------------------
  const orderByCreatedAt = () => {
    const newDirection = orderByCreatedDate === "ASC" ? "DESC" : "ASC";
    setOrderByCreateDate(newDirection);
    setFieldName("createdAt");
    setDirection(newDirection);
  };
  //--------------delete-resource------------------------
  const deleteResource = async () => {
    try {
      const res = await deleteResourceApi(statusId);
      if (res?.data?.status === 200) {
        successMessage(res);
        setDeleteModal(false);
        fathResourceList();
      } else {
        elseMessage(res);
      }
    } catch (e) {
      catchMessage(e);
    }
  };
  //------------------listing-Api----------------------------------
  const fathResourceList = async (
    page = activePage,
    search = debounceValue,
    sortField = fieldName,
    sortDirection = direction,
    startDate = searchStartDate,
    endDate = searchEndDate,
    categoryId = categoryIds
  ) => {
    setResourceList([]);
    showLoader();
    try {
      const res = await fathResourceApi({
        page,
        search,
        sortField,
        sortDirection,
        startDate,
        endDate,
        categoryId,
      }); //sortField, sortDirection,
      if (res?.data?.status === 200) {
        // console.log("resource list", res?.data?.data)
        setResourceList(res?.data?.data?.resources || []);
        setTotal(res?.data?.data?.total || 0);
        hideLoader();
      } else {
        setResourceList([]);
        setTotal(0);
        hideLoader();
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
      hideLoader();
    }
  };

  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    fathResourceList(activePage, debounceValue, fieldName, direction);
  }, [activePage, debounceValue, fieldName, direction, categoryIds]);
  useEffect(() => {
    const fathCategory = async () => {
      setCategoryList([]);
      try {
        const res = await masterCategory({});
        if (res?.data?.status === 200) {
          setCategoryList(res?.data?.data?.list || []);
        } else {
          elseMessage(res);
          setCategoryList([]);
        }
      } catch (err) {
        catchMessage(err);
        setCategoryList([]);
      }
    };
    fathCategory();
  }, []);

  useEffect(() => {
    if (
      (searchStartDate && searchEndDate) ||
      (searchStartDate === "" && searchEndDate === "") ||
      (searchStartDate === null && searchEndDate === null)
    ) {
      fathResourceList(
        activePage,
        debounceValue,
        fieldName,
        direction,
        searchStartDate,
        searchEndDate
      );
    }
    if (!searchStartDate) {
      searchParam.delete("startDate");
    }
    if (!searchEndDate) {
      searchParam.delete("endDate");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
  }, [searchStartDate, searchEndDate]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
  }, [search]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Resource Library</h4>
            <Button to={"/resource-management/add"}>Create Resource</Button>
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search">
              <input
                type="search"
                className="form-control"
                placeholder="Search name"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="form-group select_width">
              <Select
                type="text"
                className="form-control"
                name="category"
                value={categoryIds}
                onChange={(e) => setCategoryId(e.target.value)}
              >
                <option value="">Select Category</option>
                {categoryList.length > 0 &&
                  categoryList.map(({ _id, title }) => {
                    return (
                      <option key={_id} value={_id}>
                        {title}
                      </option>
                    );
                  })}
              </Select>
            </div>
            <div className="form-group date_picker">
              <DatePicker
                className="form-control"
                name="startDate"
                selected={searchStartDate}
                placeholder="Start Date"
                onChange={(date) => handleStartDate(date)}
                maxDate={searchEndDate}
              />
            </div>
            <div className="form-group date_picker">
              <DatePicker
                name="endDate"
                className="form-control"
                placeholder="End Date"
                selected={searchEndDate}
                onChange={(date) => handleEndDate(date)}
                minDate={searchStartDate}
              />
            </div>
            <div className="form-group refresh_button">
              <SecondaryButton onClick={refreshHandler}>
                <RotateLeftIcon />
              </SecondaryButton>
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Resource Name</th>
                  <th>
                    <div className="sorting-th" onClick={orderByFunds}>
                      <span>Funds Invested</span>
                      {orderByFund === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="sorting-th" onClick={orderByCreatedAt}>
                      <span>Create Date</span>
                      {orderByCreatedDate === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>Description</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>
              <tbody>
                {resourceList.length > 0 ? (
                  resourceList.map(
                    (
                      {
                        _id,
                        title,
                        totalInvestedAmount,
                        createdAt,
                        description,
                        status,
                      },
                      index
                    ) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{++index + (activePage - 1) * 10}</td>
                            <td>{title || "N/A"}</td>
                            <td>
                              {cashConverter(totalInvestedAmount) || "N/A"}
                            </td>
                            <td>{dateFormat(createdAt) || "N/A"}</td>
                            <td>
                              <ViewMore
                                value={description}
                                handleSeeMore={handleSeeMore}
                              />
                            </td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <Switch
                                  checked={status}
                                  onChange={() =>
                                    statusUpdateHandler(_id, status, title)
                                  }
                                />
                                <EditIcon
                                  to={`/resource-management/edit/${_id}`}
                                />
                                <ViewIcon
                                  to={`/resource-management/view/${_id}`}
                                />
                                <DeleteIcon
                                  onClick={() => handleDelete(_id, title)}
                                />
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No Resource Found!"
                    icon={<PsychologySharpIcon style={{ fontSize: 48 }} />}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            total={total}
            activePage={activePage}
            handlePageChange={handlePageChange}
          />
        </div>
        {/* --------status-change---------- */}
        <ChangeStatusResource
          show={statusModal}
          close={() => setStatusModal(false)}
          id={statusId}
          name={statusName}
          status={statusValue}
          listing={fathResourceList}
        />
        {/* --------show-value-from-api---------- */}
        <DescriptionModal
          show={moreModal}
          close={() => setMoreModal(false)}
          value={moreValue}
        />

        {/*/---------delete-modal---------------- */}
        <DeleteModal
          show={deleteModal}
          close={setDeleteModal}
          name={statusName}
          title="Delete Resource"
          action={deleteResource}
        />
      </div>
    </>
  );
};

export default ResourceManagement;
